(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio-password-page"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('studio-password-page')) {
  customElements.define('studio-password-page', class extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this._click = (event) => {
        if (!(event.target instanceof Element)) return;
        const dialog = this.querySelector('[data-sp-dialog]');
        if (event.target.closest('[data-sp-open]') && dialog && !dialog.open) dialog.showModal();
        if (event.target.closest('[data-sp-close]')) dialog?.close();
        if (event.target === dialog) {
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        }
      };
      this.addEventListener('click', this._click);
      this._timer = this.querySelector('[data-sp-timer]');
      if (this._timer) {
        const value = this._timer.dataset.deadline || '';
        this._deadline = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d{1,3})?)?(?:Z|[+-]\d{2}:\d{2})$/.test(value) ? Date.parse(value) : NaN;
        if (Number.isFinite(this._deadline)) {
          this._tick();
          if (this._deadline > Date.now()) this._interval = setInterval(() => this._tick(), 1000);
        } else {
          this._timer.querySelector('[data-sp-timer-grid]').hidden = true;
          const error = this._timer.querySelector('[data-sp-date-error]');
          if (error) error.hidden = false; else this._timer.hidden = true;
        }
      }
      const login = this.querySelector('[data-sp-login-error]');
      if (login && !login.open && this.dataset.editor !== 'true') login.showModal();
    }
    _tick() {
      const remaining = Math.max(0, Math.ceil((this._deadline - Date.now()) / 1000));
      const units = {days:Math.floor(remaining/86400),hours:Math.floor(remaining/3600)%24,minutes:Math.floor(remaining/60)%60,seconds:remaining%60};
      Object.entries(units).forEach(([key,value]) => {
        const node = this._timer.querySelector('[data-sp-unit="'+key+'"]');
        if (node) node.textContent = String(value).padStart(2,'0');
      });
      if (remaining === 0) {
        this._timer.querySelector('[data-sp-timer-grid]').hidden = true;
        this._timer.querySelector('[data-sp-expired]').hidden = false;
        clearInterval(this._interval);
      }
    }
    disconnectedCallback() {
      clearInterval(this._interval);
      this.removeEventListener('click', this._click);
      this._connected = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
